import { ElementIdentifier } from '@wix/editor-platform-sdk-types';
import { CheckedState } from '@wix/editor-platform-host-integration-apis';

import { getIdentifierFromRoleAndSubRole } from './getIdentifierForRoleAndSubRole';

export const updateDescriptors = async (
  _descriptors: void | Promise<void> | Promise<ElementIdentifier[]>,
  isToggled: boolean,
): Promise<CheckedState> => {
  let descriptors: ElementIdentifier[] = [];

  if (
    typeof _descriptors === 'object' &&
    typeof _descriptors.then === 'function'
  ) {
    const result = await _descriptors;

    if (Array.isArray(result)) {
      descriptors = result;
    }
  }

  if (descriptors && Array.isArray(descriptors)) {
    return descriptors.reduce((acc, descriptor) => {
      const identifier = getIdentifierFromRoleAndSubRole(descriptor);

      return {
        ...acc,
        [identifier]: isToggled,
      };
    }, {});
  }

  return {};
};
